import React from 'react';
import { CheckCircle, ArrowRight, ExternalLink, Mic } from 'lucide-react';
import SEO from '../../components/SEO';
import Section from '../../components/v2/Section';
import { PrimaryCTA } from '../../components/v2/CTAButton';

export default function Booked() {
  return (
    <main className="font-body text-[#475569] bg-[#F6F8FB]">
      <SEO
        title="You're booked | Audio & Co"
        description="Your Pro Plan fit call is confirmed. Here's everything we'd love you to bring so we can hit the ground running."
        url="https://audioandco.com/booked"
        noindex
      />

      <Section bg="bg" innerClassName="!py-16 sm:!py-20" testId="booked-page">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 rounded-full bg-[#D9FBEA] flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-9 h-9 text-[#1E2A44]" />
          </div>
          <h1 className="font-display font-bold text-[#1E2A44] text-4xl sm:text-5xl leading-[1.1] tracking-tight">
            You’re booked.
          </h1>
          <p className="text-lg text-[#475569] mt-5 leading-relaxed">
            Brilliant. You’ll receive a calendar invite shortly with the call details.
            Here’s how to make the most of our 30 minutes together.
          </p>
        </div>

        <div className="mt-10 max-w-2xl mx-auto bg-white border border-[#E2E8F0] rounded-[14px] p-6 sm:p-8 shadow-[0_10px_30px_rgba(30,42,68,0.04)]">
          <h2 className="font-display font-semibold text-[#1E2A44] text-xl">Please bring along:</h2>
          <ul className="mt-4 space-y-4">
            <li>
              <div className="flex items-center gap-2 text-[#1E2A44] font-display font-semibold">
                <ExternalLink className="w-4 h-4 text-[#BC516F]" /> Your website URL
              </div>
              <p className="text-[#64748B] text-sm mt-1 ml-6">So we can take a quick look before the call.</p>
            </li>
            <li>
              <div className="flex items-center gap-2 text-[#1E2A44] font-display font-semibold">
                <Mic className="w-4 h-4 text-[#BC516F]" /> Your current podcast / YouTube link (if you have one)
              </div>
              <p className="text-[#64748B] text-sm mt-1 ml-6">Even if it’s dormant. Especially if it’s dormant.</p>
            </li>
            <li>
              <div className="flex items-center gap-2 text-[#1E2A44] font-display font-semibold">
                <ArrowRight className="w-4 h-4 text-[#BC516F]" /> Your top conversion goal
              </div>
              <p className="text-[#64748B] text-sm mt-1 ml-6">What do you want this content to ultimately drive customers towards?</p>
            </li>
          </ul>
        </div>

        <div className="mt-10 text-center">
          <p className="text-[#64748B]">Got something to share now? Email it to <a href="mailto:hello@audioandco.com" className="text-[#BC516F] hover:text-[#A7468A] font-semibold">hello@audioandco.com</a>.</p>
          <div className="mt-6">
            <PrimaryCTA to="/" data-testid="booked-home-cta">Back to home <ArrowRight className="w-4 h-4" /></PrimaryCTA>
          </div>
        </div>
      </Section>
    </main>
  );
}
